import { useState } from "react";
import { Button } from "@mui/material";

import { GovernanceUploadModal } from "./GovernanceUpload.Modal";

type GovernanceUploadButtonProps = {
  organizationId: string;
};

/** Botão + modal juntos: usado na aba Atividade e no estado sem nenhum upload ainda. */
export function GovernanceUploadButton({ organizationId }: GovernanceUploadButtonProps) {
  const [isModalUploadOpen, setIsModalUploadOpen] = useState(false);

  return (
    <>
      <Button
        variant="outlined"
        style={{"paddingTop":"0.25rem","paddingBottom":"0.25rem","paddingLeft":"1rem","paddingRight":"1rem","borderRadius":"0.375rem","height":"2.5rem","fontSize":"0.875rem","lineHeight":"1.25rem","fontWeight":600}}
        onClick={() => setIsModalUploadOpen(true)}
      >
        Carregar Beneficiários
      </Button>

      <GovernanceUploadModal
        organizationId={organizationId}
        isOpen={isModalUploadOpen}
        onClose={() => setIsModalUploadOpen(false)}
      />
    </>
  );
}
